import { Injectable } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { AppService } from '../app.service';
import {
    ACCESS_KEYS,
    LocalStorageService,
} from '../shared/services/local-storage.service';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    user$: any;
    constructor(
        private appService: AppService,
        private localStorageService: LocalStorageService,
    ) {}
    public isAuthenticated(): boolean {
        let token = this.appService.getAuthToken || '';
        if (token === 'undefined' || token === null) {
            return false;
        } else {
            const decodeToken: any = jwtDecode(token);
            if (decodeToken.exp < new Date().getTime()) {
                return false;
            } else {
                return true;
            }
        }
    }

    public isPasswordUpdated(): any {
        const token = this.appService.getAuthToken;
        if (token === 'undefined' || token === null) {
            return false;
        } else {
            const decodeToken: any = jwtDecode(token);
            if (decodeToken.user.isPasswordUpdated === false) {
                return false;
            } else {
                return true;
            }
        }
    }

    public getToken(): string {
        return this.appService.getAuthToken;
    }

    public getDecodedToken(): any | null {
        const token = this.appService.getAuthToken;
        if (!token || token === 'undefined') return null;
        try {
            return jwtDecode(token);
        } catch (e) {
            console.error('Error decoding token:', e);
            return null;
        }
    }

    public setTokenMetadata(token: string): void {
        this.appService.setAuthToken(token);
        this.localStorageService.setItem(ACCESS_KEYS.AUTH_TOKEN, token);

        const decoded: any = jwtDecode(token);
        const user = decoded?.user;
        const pressroom = decoded?.pressroom;

        this.localStorageService.setItem(
            ACCESS_KEYS.CURRENT_ACCOUNT,
            user.accountId || '',
        );

        this.localStorageService.setItemSafe(
            ACCESS_KEYS.CURRENT_PRESSROOM,
            pressroom?.pressroomId,
        );

        this.localStorageService.setItemSafe(
            ACCESS_KEYS.CURRENT_PRESSROOM_PATH,
            pressroom?.path,
        );
    }
}
